import { useEffect, useState } from "react";
import api, { apiError } from "../lib/api";
import { toast } from "sonner";
import { Play, PauseCircle, OctagonX, Import, RotateCcw } from "lucide-react";

const STATUS_LABEL = {
  stopped: { t: "DURDURULDU", c: "#64748B" },
  running: { t: "ÇALIŞIYOR", c: "#10B981" },
  paused: { t: "GİRİŞLER DURDURULDU", c: "#F59E0B" },
  emergency_stopped: { t: "ACİL KAPATMA SÜRÜYOR", c: "#EF4444" },
};
const isV2 = () => true;
const botStatus = (status) => status?.v3_bot_status;

export default function ControlPanel({ status, onChange }) {
  const [busy, setBusy] = useState("");
  const [foreign, setForeign] = useState([]);
  const st = STATUS_LABEL[botStatus(status)] || STATUS_LABEL.stopped;
  const q = "";

  useEffect(() => {
    const load = () => api.get("/v3/positions/foreign").then((r) => setForeign(r.data.symbols || [])).catch(() => {});
    load();
    const i = setInterval(load, 15000);
    return () => clearInterval(i);
  }, []);

  const resetAll = async () => {
    if (!window.confirm("SIFIRLA: Borsadaki TÜM açık emirler iptal edilecek, TÜM pozisyonlar (bot dışı dahil) piyasa fiyatından kapatılacak, bot geçmişi/istatistikleri arşivlenecek ve B0 = 1.000 USDT yapılacak. Bu işlem geri alınamaz. Onaylıyor musunuz?")) return;
    if (!window.confirm("Son onay: tüm pozisyonlar KAPATILSIN ve geçmiş SIFIRLANSIN mı?")) return;
    setBusy("reset");
    try {
      const { data } = await api.post("/v3/reset");
      toast.success(`Sıfırlandı: ${data.closed.length} pozisyon kapatıldı, ${data.archived} kayıt arşivlendi, B0 = 1.000 USDT. Şimdi Başlat'a basın.`);
      if (data.failed?.length) toast.error(`Kapatılamayan: ${data.failed.join(", ")}`);
      setForeign([]);
      onChange?.();
    } catch (e) { toast.error(apiError(e)); }
    setBusy("");
  };

  const adopt = async () => {
    if (!window.confirm(`Borsadaki ${foreign.length} bot dışı pozisyon bota aktarılsın mı? Bot bunları +%ROI hedefinde kapatır ve −%ROI'de ekleme yapar.`)) return;
    setBusy("adopt");
    try {
      const { data } = await api.post("/v3/positions/adopt");
      toast.success(`${data.adopted.length} pozisyon bota aktarıldı${data.skipped.length ? `, ${data.skipped.length} atlandı` : ""}`);
      setForeign([]);
      onChange?.();
    } catch (e) { toast.error(apiError(e)); }
    setBusy("");
  };

  const act = async (path, label, confirmMsg) => {
    if (confirmMsg && !window.confirm(confirmMsg)) return;
    setBusy(path);
    try {
      await api.post(path);
      toast.success(label);
      onChange?.();
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="bg-[#121724] border border-[#1E2738] rounded-lg p-4 sm:p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-head text-base sm:text-lg font-semibold">Kontrol Paneli — Rotarsi Al Sat Botu</h3>
        <div className="flex items-center gap-2" data-testid="bot-status-indicator">
          <span className="h-2 w-2 rounded-full dot-blink" style={{ background: st.c }} />
          <span className="text-xs font-bold tracking-wide" style={{ color: st.c }}>{st.t}</span>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <button
          data-testid="start-bot-button"
          disabled={busy || botStatus(status) === "running"}
          onClick={() => act(`/control/start${q}`, "Bot başlatıldı")}
          className="flex items-center justify-center gap-2 bg-[#10B981]/15 hover:bg-[#10B981]/25 border border-[#10B981]/40 text-[#10B981] font-semibold text-sm rounded-md py-3 transition-colors disabled:opacity-40"
        >
          <Play className="h-4 w-4" /> Başlat / Devam Et
        </button>

        <button
          data-testid="pause-bot-button"
          disabled={busy}
          onClick={() => act(`/control/pause${q}`, "Yeni işlemler durduruldu")}
          className="flex items-center justify-center gap-2 bg-[#F59E0B]/15 hover:bg-[#F59E0B]/25 border border-[#F59E0B]/40 text-[#F59E0B] font-semibold text-sm rounded-md py-3 transition-colors disabled:opacity-40"
        >
          <PauseCircle className="h-4 w-4" /> Yeni İşlemleri Durdur
        </button>

        <button
          data-testid="emergency-stop-button"
          disabled={busy}
          onClick={() =>
            act(`/control/emergency-stop${q}`, isV2(status) ? "Acil durdurma uygulandı; bot durduruldu" : "Tüm pozisyonlar kapatıldı, bot yeniden başlatıldı",
              isV2(status) ? "ACİL DURDUR VE TÜMÜNÜ KAPAT: Tüm bot pozisyonları demo borsasında kâr/zarar ayrımı olmadan kapatılacak; bot DURACAK (manuel Başlat gerekir). Bot dışı pozisyonlara dokunulmaz. Onaylıyor musunuz?"
                : "ACİL DURDURMA: Tüm bot pozisyonları piyasa fiyatından kapatılacak ve bot hemen OTOMATİK yeniden başlayacak. Onaylıyor musunuz?")
          }
          className="flex items-center justify-center gap-2 bg-[#EF4444]/15 hover:bg-[#EF4444]/25 border border-[#EF4444]/50 text-[#EF4444] font-bold text-sm rounded-md py-3 transition-colors disabled:opacity-40"
        >
          <OctagonX className="h-4 w-4" /> {isV2(status) ? "ACİL DURDUR VE TÜMÜNÜ KAPAT" : "ACİL: HEPSİNİ KAPAT & YENİDEN BAŞLA"}
        </button>
      </div>
      {!status?.readonly && (
        <div data-testid="reset-box" className="mt-3 flex flex-wrap items-center justify-between gap-3 bg-[#0B0E17] border border-[#2A364F] rounded-md px-4 py-3">
          <div className="text-xs text-[#94A3B8]"><span className="font-semibold text-[#F1F5F9]">Sıfırdan başla:</span> borsadaki TÜM açık emirleri iptal eder, TÜM pozisyonları (bot dışı dahil) piyasa fiyatından kapatır, geçmiş/istatistikleri arşivler ve B0 = 1.000 USDT yapar. Bot DURUR; sonra Başlat'a basın.</div>
          <button data-testid="reset-all-button" disabled={!!busy} onClick={resetAll} className="shrink-0 flex items-center gap-1.5 border border-[#EF4444]/60 text-[#EF4444] hover:bg-[#EF4444]/10 font-bold text-xs rounded-md px-3 py-2 disabled:opacity-50">
            <RotateCcw className="h-3.5 w-3.5" /> SIFIRLA (B0 = 1.000)
          </button>
        </div>
      )}
      {foreign.length > 0 && !status?.readonly && (
        <div data-testid="foreign-positions-box" className="mt-3 flex flex-wrap items-center justify-between gap-3 bg-[#F59E0B]/10 border border-[#F59E0B]/40 rounded-md px-4 py-3">
          <div className="text-xs">
            <div className="font-semibold text-[#F59E0B] flex items-center gap-1.5"><Import className="h-3.5 w-3.5" /> Borsada bot dışı {foreign.length} açık pozisyon var</div>
            <div className="text-[#94A3B8] font-mono mt-0.5 break-all">{foreign.join(", ")}</div>
            <div className="text-[#64748B] mt-0.5">Bota aktarırsanız +%ROI çıkış ve ekleme kuralları bunlara da uygulanır; aktarmazsanız dokunulmaz.</div>
          </div>
          <button data-testid="adopt-positions-button" disabled={busy} onClick={adopt} className="shrink-0 flex items-center gap-1.5 bg-[#F59E0B] hover:bg-[#D97706] text-[#0B0E17] font-bold text-xs rounded-md px-3 py-2 disabled:opacity-50">
            <Import className="h-3.5 w-3.5" /> Pozisyonları Sahiplen
          </button>
        </div>
      )}
      <p className="text-[11px] text-[#64748B] mt-3">
        {isV2(status)
          ? '"Yeni İşlemleri Durdur" girişleri durdurur, bekleyen girişleri iptal eder, açık pozisyon yönetimi sürer. "Acil Durdur" tüm bot pozisyonlarını kapatır ve botu durdurur. Başlat: mutabakat tamam ve risk kilidi ihlali yoksa çalışır.'
          : '"Yeni İşlemleri Durdur" mevcut pozisyonların çıkış yönetimini sürdürür. "Acil" tüm bot pozisyonlarını kâr/zarar ayırt etmeden kapatır ve bot otomatik olarak yeniden başlar. Normal akışta her pozisyon yalnızca kendi eşiğiyle kapanır.'}
      </p>
    </div>
  );
}
